import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SectionRenderer from "@/components/site/SectionRenderer";
import SEO from "@/components/site/SEO";
import NotFound from "@/pages/NotFound";
import { useLanguage } from "@/i18n/LanguageContext";
import { bi } from "@/lib/bilingual";

const PageRenderer = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const { t, lang } = useLanguage();

  useEffect(() => {
    api.get(`/pages/public/${slug}`).then(({ data }) => setPage(data)).catch(() => setPage(false));
    window.scrollTo(0, 0);
  }, [slug]);

  if (page === null) return <div className="pt-40 text-center text-zinc-500">{t("common.loading")}</div>;
  if (page === false) return <NotFound />;

  return (
    <div>
      <SEO
        title={bi(page.seo_title, lang) || page.title}
        description={bi(page.seo_description, lang)}
        breadcrumbs={[
          { name: t("nav.home"), url: window.location.origin + "/" },
          { name: page.title, url: window.location.href },
        ]}
      />
      <div className="pt-6" />
      {(page.sections || []).map((s) => (
        <SectionRenderer key={s.id} section={s} />
      ))}
    </div>
  );
};

export default PageRenderer;
